import { useUpdateOrgShortLinkEnabled } from "@/apiQueries/useUpdateOrgShortLinkEnabled";

import { useRedux } from "@/hooks/useRedux";
import { useSettingsToggle } from "@/hooks/useSettingsToggle";

import { CardWithToggler } from "./CardWithToggler";

export const SettingsEnableShortLinking = () => {
  const { organization } = useRedux("organization");
  const { isChecked, isPending, error, handleToggleChange } = useSettingsToggle({
    currentValue: Boolean(organization.data.isLinkShortenerEnabled),
    useUpdateMutation: useUpdateOrgShortLinkEnabled,
    getNextValue: (current) => !current,
  });

  return (
    <CardWithToggler
      toggleId="short-linking"
      label="Enable short linking"
      note={
        <>
          Select this option to use shorter links when inviting receivers. The short link format
          will look like <code>{organization.data.baseUrl}/r/abcd1234</code>.
        </>
      }
      isChecked={isChecked}
      isPending={isPending}
      error={error}
      onToggleChange={handleToggleChange}
    />
  );
};
